import React from 'react';
import { PluginEnum } from '@meitu/saas-editor-core/es/version-types';
import { ArtTextButton } from '@meitu/saas-editor-ui/es/components/art-text-button';
import useOpenPlugins from '@/editor/collapse/views/more-collapse/hooks/use-open-plugins';
import { useDragLayer } from '@/hooks/use-drag-layer';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { isIntl } from '@/react-process-env';
import { useRecordModel } from '@/store/models/record-model';
import { useSdkModel } from '@/store/models/sdk-model';
import './style.less';

export const ShortcutButtons: React.FC = () => {
    const { $t } = useLocaleStore();

    const { openPlugin } = useOpenPlugins();

    const customParams = useSdkModel((state) => state.customParams);
    const getRecordInfo = useRecordModel((state) => state.getRecordInfo);
    const dragLayerHelper = useDragLayer();

    const showArtTextButton = !isIntl && !customParams.hideTextMenuContent;

    const addTrack = () => {
        const recordId = getRecordInfo().id;

        window._stat_track('tpbj_subfunction_click', {
            func: '12_50',
            click_type: 1,
            open: 1,
            record_id: recordId,
        });

        window._stat_track('tpbj_subfunction_tick', {
            func: '12_50',
            record_id: recordId,
        });
    };

    const addDefaultTitle = (byMousePosition?: boolean) => {
        editor.textLayer.addDefaultTitle({ byMousePosition });
        addTrack();
    };

    const addDefaultSubTitle = (byMousePosition?: boolean) => {
        editor.textLayer.addDefaultSubTitle({ byMousePosition });
        addTrack();
    };

    const addDefaultContent = (byMousePosition?: boolean) => {
        editor.textLayer.addDefaultContent({ byMousePosition });
        addTrack();
    };

    const openArtTextPlugin = () => {
        openPlugin({ func: PluginEnum.AI_TEXT });
        window._stat_track('tpbj_subfunction_click', {
            func: '12_122',
            click_type: 1,
            open: 1,
            record_id: getRecordInfo().id,
        });
    };

    return (
        <div className="shortcut-buttons">
            <p className="shortcut-buttons__desc">{$t((v) => v.collapse.textCollapse.clickToAddText)}</p>
            <ul className="shortcut-buttons__buttons">
                <li
                    className="shortcut-buttons__button shortcut-buttons__button--title"
                    onClick={() => addDefaultTitle(false)}
                    draggable="true"
                    onMouseDown={(ev) => {
                        console.log('onMouseDown');
                        dragLayerHelper.init(
                            {
                                callback: () => addDefaultTitle(true),
                            },
                            ev,
                        );
                    }}
                    onMouseUp={() => {
                        dragLayerHelper.destroy();
                    }}
                >
                    {$t((v) => v.collapse.textCollapse.title)}
                </li>
                <li
                    className="shortcut-buttons__button shortcut-buttons__button--sub-title"
                    onClick={() => addDefaultSubTitle(false)}
                    draggable="true"
                    onMouseDown={(ev) => {
                        console.log('onMouseDown');
                        dragLayerHelper.init(
                            {
                                callback: () => addDefaultSubTitle(true),
                            },
                            ev,
                        );
                    }}
                    onMouseUp={() => {
                        dragLayerHelper.destroy();
                    }}
                >
                    {$t((v) => v.collapse.textCollapse.subTitle)}
                </li>
                <li
                    className="shortcut-buttons__button shortcut-buttons__button--content"
                    onClick={() => addDefaultContent(false)}
                    draggable="true"
                    onMouseDown={(ev) => {
                        console.log('onMouseDown');
                        dragLayerHelper.init(
                            {
                                callback: () => addDefaultContent(true),
                            },
                            ev,
                        );
                    }}
                    onMouseUp={() => {
                        dragLayerHelper.destroy();
                    }}
                >
                    {$t((v) => v.collapse.textCollapse.contentText)}
                </li>
            </ul>
        </div>
    );
};
